import { defineRule, configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import { required, email } from '@vee-validate/rules'
import de from '@vee-validate/i18n/dist/locale/de.json'

export default defineNuxtPlugin(() => {
  defineRule('required', required)
  defineRule('email', email)

  // register locales

  configure({
    // controls if `blur` events should trigger validation with `handleChange` handler
    validateOnBlur: true,
    // controls if `change` events should trigger validation with `handleChange` handler
    validateOnChange: true,
    // controls if `input` events should trigger validation with `handleChange` handler
    validateOnInput: true,
    // controls if `update:modelValue` events should trigger validation with `handleChange` handler
    validateOnModelUpdate: true,

    generateMessage: localize({
      de,
    }),
  })
})
